import styled, { css } from "styled-components";
import {styledByDevice} from "../../../../../themes/architecture/styled-by-device";
import { ISearchFormResultsProps } from "./search-form-results.box.props";

const DefaultBox = styled.div<ISearchFormResultsProps>`
    flex: 1;
    background-size: 4px 4px;
`;

const MobileBox = styled(DefaultBox)`
    padding: 1rem;
    margin: 1rem 0;
    background: linear-gradient(-45deg,rgba(252,246,213,0.8) 33.33%,rgba(25,50,47,0.1) 33.33%,rgba(25,50,47,0.2) 50%,rgba(252,246,213,0.8) 50%,rgba(252,246,213,0.8) 83.33%,rgba(25,50,47,0.1) 83.33%,rgba(25,50,47,0.1) 100%);
    ${props => props.isHybridAndroid ? css`padding-bottom: 500px;` : ""}
`;

const PCBox = styled(DefaultBox)`
    position: absolute;
    width: 45rem;
    margin: 5rem 0 0 0;
    padding: 1rem 1rem 1rem 5rem;
    border-radius: 5px;
    background: ${props => props.theme.colors.background};
    border: 1px solid ${props => props.theme.colors.boxBorderLight};
`;

export const SearchFormResultsCasino777Box = styledByDevice(PCBox, MobileBox);